import IResource from '../models/IResource';
import AbstractCRUDService from './AbstractCRUDService';

class ResourceService extends AbstractCRUDService<IResource> {}

export default new ResourceService('logistics/resource');
